exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unavailableCards[data-v-13fda047] {\r\n  color: red;\n}\n.block__form__actions__submit[data-v-13fda047]{\r\n  margin-top: 2rem;\n}\n.wrap[data-v-13fda047] {\r\n  position: relative;\n}\n@media (max-width: 991px) {\n.wrap[data-v-13fda047] {\r\n    background-color: #fff\r\n    /* padding-top: 5vh; */\n}\n}\n.form-charge[data-v-13fda047] {\r\n  background-color: #fff;\r\n  padding-top: 2rem;\r\n  padding-bottom: 5rem;\n}\n@media (min-width: 992px) {\n.form-charge[data-v-13fda047] {\r\n    padding-top: 0;\r\n    max-width: 500px\n}\n}\r\n", ""]);

// exports
